import { useHydrateAtoms } from 'jotai/utils';

import {
  GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_shipping_fee as ShippingFee,
  PdpCatalogFulfillmentType,
} from '../graphql/select-option_types.2';
import {
  ActiveIndexAtom,
  ActiveParentIndexAtom,
  BogoInfoAtom,
  BogoRequiredQuantityAtom,
  displayDeliveryTypeToggleButtonAtom,
  IsProductTypeZigzinAtom,
  MachingOptionAtom,
  OptionsAtom,
  OptionSourceDataAtom,
  OriginOptionDataAtom,
  ProductIdAtom,
  ProductItemListAtom,
  SelectedOptionRestockNotiInfoAtom,
  TextOptionsAtom,
} from '../store/baseAtoms';
import { initData, setIsZigzinOfValueList } from '../store/util';
import { initActiveIndex, initOptions, initTextOptions } from '../store/utils/init';
import { CustomOptionsInfo, RestockNotificationInfo } from '../types/option-type';

export const useOptionHydrate = ({
  options,
  shipping_fee,
}: {
  options: CustomOptionsInfo;
  shipping_fee: ShippingFee;
}) => {
  const bogoInfo = options.promotion_info?.bogo_info ?? null;
  const bogo_required_quantity = bogoInfo?.required_quantity ?? null;

  const isProductTypeZigzin = options.fulfillment_type === PdpCatalogFulfillmentType.ZIGZIN;
  const covertedIsZigzinOptionData = setIsZigzinOfValueList(options, shipping_fee);
  const covertOptionData = initData(covertedIsZigzinOptionData, false);

  return useHydrateAtoms([
    [displayDeliveryTypeToggleButtonAtom, covertOptionData.is_only_zigzin_button_visible],
    [BogoInfoAtom, bogoInfo],
    [BogoRequiredQuantityAtom, bogo_required_quantity],
    [OptionSourceDataAtom, covertedIsZigzinOptionData],
    [OriginOptionDataAtom, covertOptionData],
    [ProductIdAtom, covertOptionData.id],
    [TextOptionsAtom, initTextOptions(covertOptionData, bogo_required_quantity)],
    [SelectedOptionRestockNotiInfoAtom, {} as RestockNotificationInfo],
    [OptionsAtom, initOptions(covertOptionData.product_option_list, bogo_required_quantity)],
    [ActiveIndexAtom, initActiveIndex(covertOptionData)],
    [ActiveParentIndexAtom, initActiveIndex(covertOptionData)],
    [ProductItemListAtom, covertOptionData.matched_item_list],
    [IsProductTypeZigzinAtom, isProductTypeZigzin],
    [MachingOptionAtom, covertOptionData.matching_catalog_product_info?.option_list ?? null],
  ] as const);
};
